export enum SearchType {
  ADVANCED = 'ADVANCED',
  QUICK = 'QUICK'
}
